export default [
    {
        _name: 'CSidebarNav',
        _children: [
            // {
            //     _name: 'CSidebarNavItem',
            //     code: 'home',
            //     name: 'Trang chủ',
            //     route: '/home',
            //     icon: 'cil-home'
            // },
            {
                _name: 'CSidebarNavDropdown2',
                code: 'system',
                name: 'Quản lý hệ thống',
                route: '/system',
                icon: 'cil-settings',
                items: [
                    {
                        code: 'manage_users',
                        name: 'Người dùng',
                        to: '/system/users',
                        icon: 'cil-user',
                        requiresPrivileges: ['ViewUser', 'ManageUser']
                    },
                    {
                        code: 'manage_roles',
                        name: 'Nhóm người dùng',
                        to: '/system/roles',
                        icon: 'cil-people',
                        requiresPrivileges: ['ViewRole', 'ManageRole']
                    },
                    //{
                    //    code: 'group_menus',
                    //    name: 'Nhóm menu',
                    //    to: '/system/group-menus',
                    //    icon: 'cil-people',
                    //    requiresPrivileges: []
                    //},
                    {
                        code: 'menus',
                        name: 'Menu',
                        to: '/system/menus',
                        icon: 'cil-people',
                        requiresPrivileges: ['ViewMenu', 'ManageMenu']
                    },
                    {
                        code: 'slider-video-types',
                        name: 'Danh mục sliders',
                        to: '/system/slider-video-types',
                        icon: 'cil-people',
                        requiresPrivileges: ['ViewSliderVideoType', 'ManageSliderVideoType']
                    },
                    {
                        code: 'sliders',
                        name: 'Sliders',
                        to: '/system/sliders',
                        icon: 'cil-people',
                        requiresPrivileges: ['ViewSlider', 'ManageSlider']
                    },
                    {
                        code: 'config-display',
                        name: 'Cấu hình hiển thị',
                        to: '/system/config-display',
                        icon: 'cil-people',
                        requiresPrivileges: ['ViewConfigDisplay', 'ManageConfigDisplay']
                    },
                    //{
                    //    code: 'tools',
                    //    name: 'Công cụ',
                    //    to: '/system/tools',
                    //    icon: 'cil-people',
                    //    requiresPrivileges: []
                    //},
                ]
            },
            {
                _name: 'CSidebarNavDropdown2',
                code: 'manage_master_data',
                name: 'Quản lý danh mục',
                route: '/master-data',
                icon: 'cilListRich',
                items: [
                    {
                        code: 'categories',
                        name: 'Danh mục',
                        to: '/master-data/categories',
                        icon: 'cilBuilding',
                        requiresPrivileges: ['ViewCategory', 'ManageCategory']
                    },
                    {
                        code: 'products',
                        name: 'Sản phẩm',
                        to: '/master-data/products',
                        icon: 'cilListRich',
                        requiresPrivileges: ['ViewProduct', 'ManageProduct']
                    },
                ]
            },
            {
                _name: 'CSidebarNavDropdown2',
                code: 'manage_blog',
                name: 'Quản lý bài viết',
                route: '/blog',
                icon: 'cilColorBorder',
                items: [
                    {
                        code: 'category_blogs',
                        name: 'Thể loại bài viết',
                        to: '/master-data/blog-categories',
                        icon: 'cilBuilding',
                        requiresPrivileges: ['ViewBlogCategory', 'ManageBlogCategory']
                    },
                    {
                        code: 'blogs',
                        name: 'Bài viết',
                        to: '/master-data/blogs',
                        icon: 'cilBuilding',
                        requiresPrivileges: ['ViewBlog', 'ManageBlog']
                    },
                    {
                        code: 'tags',
                        name: 'Thẻ bài viết',
                        to: '/master-data/tags',
                        icon: 'cilBuilding',
                        requiresPrivileges: ['ViewTag', 'ManageTag']
                    },
                ]
            },
            {
                _name: 'CSidebarNavDropdown2',
                code: 'system_logs',
                name: 'Nhật ký hệ thống',
                route: '/logs',
                icon: 'cilLog',
                items: [
                    {
                        code: 'action_logs',
                        name: 'Nhật ký thao tác dữ liệu',
                        to: '/logs/action',
                        icon: 'cilTouchApp',
                        requiresPrivileges: ['ViewActionLog']
                    }
                ]
            }
        ]
    }
]